export default __webpack_public_path__ + "static/media/camera-monitoring.a4da89c3.svg";